import Vue from 'vue';

import '@/plugins/axios';

import App from '@/App.vue';
import store from '@/store';

import JobQueue from '@/views/JobQueue.vue';
import ReloadHistory from '@/views/ReloadHistory.vue';
import AuditLog from '@/views/AuditLog.vue';
import UpgradeJobs from '@/views/UpgradeJobs.vue';
import vuetify from './plugins/vuetify';
import router from './router';


// use following if you want /:clientId lockdown
// router.beforeEach(fiLockDown(store));
// router.beforeEach(appModeCheck(store));

// use following if you do NOT want /:clientId lockdown
store.dispatch('auth/initializePortalSession', store);

Vue.config.productionTip = false;

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  components: {
    JobQueue,
    ReloadHistory,
    UpgradeJobs,
    AuditLog,
  },
  render: h => h(App),
});
